import { Typography, Grid, Stack } from '@mui/material';
import { NavItemChildDesktop } from '../nav-item-child';
import { DropdownItem } from 'types/header';

export const FreeLayout = ({
  dropdownItems,
  closeDropdown,
}: {
  dropdownItems: DropdownItem[];
  closeDropdown: () => void;
}) => {
  // Filtra solo gli elementi che hanno un title valido e contenuto
  const validItems = dropdownItems.filter(
    item =>
      item.title &&
      item.title.trim() !== '' &&
      item.children &&
      item.children.length > 0
  );

  // Se non ci sono elementi validi, non renderizzare nulla
  if (validItems.length === 0) {
    return null;
  }

  let remain = 12;
  const sizes = Array.from({ length: validItems.length }, (_, index) => {
    const isMoreThan7 = (validItems[index]?.children?.length ?? 0) >= 7;
    const size = isMoreThan7
      ? 6
      : Math.floor(remain / (validItems.length - index));
    remain -= size;
    return size;
  });

  return (
    <Grid container spacing={validItems.length}>
      {validItems.map((item, index) => (
        <Grid item lg={sizes[index]} key={item.title}>
          <Stack
            key={item.title}
            gap={1}
            height={312}
            overflow={'hidden'}
            pr={3}
            sx={{ maxWidth: '100%' }}
            borderRight={theme =>
              index < validItems.length - 1
                ? `1px solid ${theme.palette.grey[400]}`
                : undefined
            }
          >
            <Typography variant="body1" color={'grey.600'} align="left">
              {item.title}
            </Typography>
            <NavItemChildDesktop item={item} closeDropdown={closeDropdown} />
          </Stack>
        </Grid>
      ))}
    </Grid>
  );
};
